/**
 * jQuery function to replace one or more CSS classes with others. Separate multiple
 * classes with spaces.
 * @param {string} remove - CSS classes to remove.
 * @param {string} add - CSS classes to add.
 * @example
 * $( '.selector' ).replaceClass( 'old-class', 'new-class some-other-class' );
 * $( '.selector' ).replaceClass( 'old-class another-class', 'new-class' );
 */
!function(s){s.fn.replaceClass=function(remove,add){var e=add||remove;return e&&this.removeClass(add?remove:this.className).addClass(e),this}}(jQuery);